import { ClaudeStatus, type ComponentStatus } from '../types/anthropic-status';
import { FormFactor, ResourceType, State } from '../types/ai-apps';

export const BUILD_SESSION_RESOURCE = 'build-session';
export const VINCE_AI_OPTION_VALUE = '__vince_ai__';

export interface AppResourceTypeConfig {
    type: ResourceType;
    key: string;
    selectLabelKey: string;
    selectedCountLabelKey: string;
}

export const AI_APP_RESOURCE_TYPES: AppResourceTypeConfig[] = [
    {
        type: ResourceType.CUSTOM_TABLE,
        key: 'tables',
        selectLabelKey: 'selectTables',
        selectedCountLabelKey: 'customTablesSelected'
    },
    {
        type: ResourceType.WORKFLOW,
        key: 'workflows',
        selectLabelKey: 'selectWorkflows',
        selectedCountLabelKey: 'workflowsSelected'
    },
    {
        type: ResourceType.MCP_SERVER,
        key: 'mcpServers',
        selectLabelKey: 'selectMcpServers',
        selectedCountLabelKey: 'mcpServersSelected'
    }
];

export const START_POSITION_IN_APPS_MENU = 1000;
export const MODULE_BASE_URL = '/ai-apps';
export const STATE_COLORS: Record<State, string> = {
    [State.ARCHIVED]: 'var(--primary-color-disabled)',
    [State.DRAFT]: 'var(--primary-text-muted)',
    [State.PUBLISHED]: 'var(--secondary-color)'
};

export const APP_BRIDGE_LOCAL_URL = 'https://metadata.dev.vincelive.dev/ai-apps/app-bridge-2.js';
export const API_BRIDGE_URL_PARAMETER_NAME = 'vinceApiBridgeUrl';
export const API_BRIDGE_CONTENT_PARAMETER_NAME = 'vinceApiBridgeContent';
export const API_BRIDGE_FILENAME = 'app-bridge-2.js';
export const API_BRIDGE_REQUEST_EVENT_TYPE = 'vinceRequest';
export const API_BRIDGE_RESPONSE_EVENT_TYPE = 'vinceResponse';
// host -> app push notification
export const API_BRIDGE_HOST_EVENT_TYPE = 'vinceHostEvent';
// app -> host generic publish
export const API_BRIDGE_HOST_PUBLISH_TYPE = 'vinceHostPublish';
// Default Hub-like channel used for inbound host events.
export const HOST_EVENT_DEFAULT_CHANNEL = 'vince:host';
export const API_BRIDGE_API_START_MARKER = '// bridge-api-start-marker-do-not-remove';

export const APP_IFRAME_PERMISSIONS = 'accelerometer; autoplay; camera; gyroscope; microphone; payment; usb; xr-spatial-tracking; clipboard-read; clipboard-write; encrypted-media; fullscreen; geolocation; magnetometer; microphone; midi; payment; usb; xr-spatial-tracking;';
export const APP_IFRAME_SANDBOX = 'allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox allow-downloads allow-modals allow-pointer-lock';

// Show unsaved changes warning if more than x changes since last save
export const UNSAVED_WARNING_AFTER_PROMPTS_THRESHOLD = 3;

// Re-show the unsaved changes warning this often while unsaved work still exists.
export const UNSAVED_WARNING_REMINDER_INTERVAL_MS = 30 * 60 * 1000;

// Claude API status
export const CLAUDE_API_COMPONENT_ID = 'k8w3r06qmzrp';
export const CLAUDE_API_STATUS_MAP: Record<ComponentStatus, ClaudeStatus> = {
    operational: ClaudeStatus.OPERATIONAL,
    degraded_performance: ClaudeStatus.DEGRADED,
    partial_outage: ClaudeStatus.PARTIAL_OUTAGE,
    major_outage: ClaudeStatus.MAJOR_OUTAGE,
    under_maintenance: ClaudeStatus.MAINTENANCE
};

export const FORM_FACTORS = [
    { value: FormFactor.DESKTOP, icon: 'pi pi-desktop', styles: ['border-right: 0', 'border-left: 0; border-right: 0;'], rotatable: false },
    { value: FormFactor.TABLET, icon: 'pi pi-tablet', styles: ['border-left: 0; border-right: 0', 'border-left: 0; border-right: 0'], rotatable: true },
    { value: FormFactor.HANDHELD, icon: 'pi pi-mobile', styles: ['border-left: 0; border-right: 0', 'border-left: 0;'], rotatable: true }
];
